module.exports = __webpack_public_path__ + "img/image-018.3f253443.png";